import { useEffect, useState } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import UserAvatar from "./UserAvatar";
import Box from "@mui/material/Box";
import * as styles from "../styles/WelcomeBanner.module.scss";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Constants } from "../Constants";

const WelcomeBanner = () => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [name, setName] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    if (account && account.name) {
      setName(account.name.split(" ")[0]);
    } else {
      setName("");
    }
  }, [account]);

  if (name) {
    return (
      <Box className={styles.WelcomeBanner}>
        <UserAvatar
          width={90}
          height={90}
          margin="0 10px 0 0"
          fontSize="2.5rem"
          isLink={true}
          linkTo={Constants.navigation.urls.profile}
          data-parentid="welcome-banner"
          data-id="profile-avatar"
        />
        <Box className={styles.welcomeContainer}>
          <Typography variant="h5">{t(Constants.translationKeys.welcome_banner_greeting)}</Typography>
          <Typography variant="h3" className={styles.name}>
            {name}
          </Typography>
        </Box>
      </Box>
    );
  } else {
    return null;
  }
};

export default WelcomeBanner;
